/**
 * Report submission status. Stored in lowercase in the database.
 * Display capitalized in the UI via i18n (report.status.*).
 *
 * - draft: Initial status. User has created the report and has not submitted for review.
 * - submitted: User has submitted for review. No longer able to make edits.
 * - changes_requested: Admin has reviewed and requested changes.
 * - approved: Reviewer has approved. No further action needed.
 */
export const ReportStatuses = {
	Draft: 'draft',
	Submitted: 'submitted',
	ChangesRequested: 'changes_requested',
	Approved: 'approved',
} as const;

export type ReportStatus = (typeof ReportStatuses)[keyof typeof ReportStatuses];
